import React, { Component, } from 'react'
import PropTypes from 'prop-types'

import cache from './ScriptCache'
import GoogleApi from './GoogleApi'

const defaultMapConfig = {}
export const wrapper = options => (WrappedComponent) => {
  const apiKey = options.apiKey
  const libraries = options.libraries || ['places']

  class Wrapper extends Component {
    static propTypes = {
      // eslint-disable-next-line
      lat: PropTypes.number,
      // eslint-disable-next-line
      lng: PropTypes.number,
      // eslint-disable-next-line
      zoom: PropTypes.number,
    }

    state = {
      loaded: false,
      map: null,
      google: null,
    }

    componentWillMount() {
      this.scriptCache = cache({
        google: GoogleApi({
          apiKey,
          libraries,
        }),
      })
    }

    componentDidMount() {
      const mapNode = this.map
      this.scriptCache.google.onLoad(() => {
        const maps = window.google.maps
        const center = new maps.LatLng(this.props.lat, this.props.lng)
        const mapConfig = Object.assign({}, defaultMapConfig, {
          center,
          zoom: this.props.zoom,
        })
        this.map = new maps.Map(mapNode, mapConfig)
        this.setState({
          loaded: true,
          map: this.map,
          google: window.google,
        })
      })
    }

    render() {
      const { loaded, map, google, } = this.state
      const props = Object.assign({}, this.props, {
        loaded,
        map,
        google,
        mapComponent: this.map,
      })
      return (
        <div>
          <WrappedComponent {...props} />
          <div
            ref={(c) => {
              this.map = c
            }}
          />
        </div>
      )
    }
  }

  return Wrapper
}

export default wrapper



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/lib/GoogleApiWrapper.js